export class BuilderAnimationDelta {
    public constructor(public readonly layerId: number, public readonly path: 'visible', public newValue: boolean) {}
}
